import { Container, Text, Paper } from "@mantine/core";

export default function Settings() {
  return (
    <Container size="sm" mt="xl">
      <Paper shadow="xs" p="xl" withBorder>
        <Text size="xl" fw={700} mb="md">
          Settings
        </Text>
        <Text>Settings page coming soon...</Text>
      </Paper>
    </Container>
  );
}
